import { baseTheme } from "./base";
const overrideColors = {
    heroPineGreen: "#26513B",
    springLeaves: "#4B7155",
    laurel: "#6C906E",
};
const colors = Object.assign(Object.assign(Object.assign({}, baseTheme.colors), overrideColors), { cl17: overrideColors.heroPineGreen, cl18: overrideColors.springLeaves, cl19: overrideColors.laurel });
colors.primaryLight = colors.cl17;
colors.primary = colors.cl18;
colors.primaryDark = colors.cl19;
export const nordicsTheme = Object.assign(Object.assign({}, baseTheme), { colors: Object.assign({}, colors) });
